// extracted by mini-css-extract-plugin
export default {"container":"AlertWithCheckbox__container___xP7S1"};